export default function JuridicoResultados() {
  return <div>Construção em andamento...</div>;
}
